// extracted by mini-css-extract-plugin
export var markdown = "_s6-0";
export var tableWrapper = "_s6-1";